import React, { useState, useEffect } from "react";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Container, Row, Col, Stack, Image, Modal } from 'react-bootstrap';
import { sendOTP, validateOTP } from '../../common/Utils';
import { INVALID_OTP_ERROR } from '../../common/constants';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, TextField} from '@mui/material';
import './otpValidationPopover.css'
import { handleNumberFieldFocus } from "../../common/commonFunction";

export const OTPValidationPopover = (props) => {
    const [otpValue, setOtpValue] = useState()
    const [otpSentError, setOtpSentError] = useState("")
    useEffect(() => {
        if (props.mobileNumber) {
            sendOTP(props.mobileNumber, sentOTPCallBack);
        }
    }, [])
    const sentOTPCallBack = (response) => {
        if (response.isSuccess) {
            setOtpSentError("Please enter the OTP sent to your registered mobile number.");
        }
    }
    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(props.mobileNumber, e.target.value, callBackOTPValidation);
        }
    }
    const callBackOTPValidation = (response) => {
        setOtpSentError("");
        if (response.isSuccess) {
            props.callback(props.urn, props.onClose);
        }
        else {
            setOtpSentError(INVALID_OTP_ERROR);
        }
    }
    return (
        <div>
            <Container fluid >
                <Row>
                    <Col xs={12} md={12}>
                        <Stack direction="horizontal">
                        <div className='otp-header-text'>OTP Validation</div>
                        <div className='otp-div'>
                            <IconButton aria-label="close" onClick={props.onClose}><CloseIcon /></IconButton>
                            </div>
                            </Stack>
                    </Col>
                    <Col xs={12} md={12}>
                    <TextField error={otpSentError} helperText={otpSentError} type="number" onFocus={handleNumberFieldFocus} onChange={(e) => onOtpChange(e)} value={otpValue} label="Enter OTP" />
                       </Col>
                </Row>

            </Container>

        </div>
    );
};
